// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__DDa4r","messages":"Chat_messages__1e2TA","dateDivider":"Chat_dateDivider__3PByE"};